import { ActionTypeList } from '../../constants/index'

const initialState = {
    loading: false,
    scanLaunchData: undefined,
    error: "",
};

const scanLaunchPayload = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypeList.SCAN_LAUNCHED:
            return {
                loading: false,
                scanLaunchData: action.payload,
                error: ""
            };
        case ActionTypeList.SCAN_LAUNCH:
            return {
                loading: true,
                scanLaunchData: action.payload,
                error: action.payload
            };
        case ActionTypeList.SCAN_LAUNCH_STATUS_RESET:
            return {
                ...state,
                ...initialState
            };
        default:
            return state;
    }
}

export default scanLaunchPayload;